export default [
  {
    path: '/',
    name: 'home',
    component: async () => await import('@/views/amd/HomeView.vue'),
  },
  {
    path:'/create-campaign',
    name:'create-campaign',
    component:() => import('@/views/amd/CreateCampaign.vue')
  },
  {
    path:'/insert-invoice',
    name:'insert-invoice',
    component:() => import('@/views/amd/InsertInvoice.vue')
  },
  {
    meta: { title: 'menu.editCampaign' },
    path:'/campaigns/edit/:id',
    name:'edi-campaign',
    component:() => import('@/views/amd/EditCampaign.vue')
  },
  {
    meta: { title: 'menu.ratioCoin' },
    path:'/ratio-coin',
    name:'ratio-coin',
    component:() => import('@/views/amd/RatioCoins.vue')
  }
]
